import { useState, useEffect, FC } from 'react'
import { cn } from '@wellesley/ui'

export type CountdownTimerProps = {
  initialSeconds: number
  isActive: boolean
  className?: string
  onComplete?: () => void
}

export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  const minStr = minutes ? `${String(minutes).padStart(2, '0')}:` : ''

  return `${minStr}${String(remainingSeconds).padStart(2, '0')}`
}

export const CountdownTimer: FC<CountdownTimerProps> = ({
  initialSeconds,
  className,
  isActive,
  onComplete,
}) => {
  const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds)

  useEffect(() => {
    isActive && setSecondsRemaining(initialSeconds)
  }, [isActive])

  useEffect(() => {
    if (secondsRemaining <= 0) {
      if (onComplete) onComplete()
      return
    }

    const intervalId = setInterval(() => {
      setSecondsRemaining((prevSeconds) => prevSeconds - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [secondsRemaining, onComplete])

  return (
    <div className={cn('w-l text-sm font-semibold text-gray-700', className)}>
      {formatTime(secondsRemaining)}
      {secondsRemaining < 60 && 's'}
    </div>
  )
}
